exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/deep/ .modal {\n  max-width: 350px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/projektyWeb/McComp_Flota/Front/src/app/services/prompt/confirm/confirm.component.scss
// module id = ../../../../../src/app/services/prompt/confirm/confirm.component.scss
// module chunks = main